var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"action",attrs:{"aria-label":_vm.label,"title":_vm.label},on:{"click":_vm.action}},[_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.icon))]),_c('span',[_vm._v(_vm._s(_vm.label))]),(_vm.counter > 0)?_c('span',{staticClass:"counter"},[_vm._v(_vm._s(_vm.counter))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }